// components/project-details/ProjectNotes.js
import React, { useState, useEffect } from 'react';
import styles from './ProjectDetails.module.css';

const ProjectNotes = ({ notes, onChange }) => {
  const [localNotes, setLocalNotes] = useState(notes || '');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setLocalNotes(notes || '');
  }, [notes]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (localNotes !== notes) {
        setIsSaving(true);
        onChange(localNotes);
        setTimeout(() => setIsSaving(false), 1000);
      }
    }, 500); // Debounce for 500ms

    return () => clearTimeout(timeoutId);
  }, [localNotes, notes, onChange]);

  return (
    <div className={styles.sectionCard}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: 'var(--spacing-s)' 
      }}>
        <h3 className={styles.sectionTitle} style={{ margin: 0 }}>Project Notes</h3>
        {isSaving && (
          <span className={styles.savingIndicator}>
            <div className={styles.spinner} style={{ width: '0.75rem', height: '0.75rem' }}></div>
            Saving...
          </span>
        )}
      </div>
      <textarea
        value={localNotes}
        onChange={(e) => setLocalNotes(e.target.value)}
        placeholder="Add any project notes, reminders, or important details here..."
        className={styles.notesTextarea}
      />
      <div style={{ 
        fontSize: 'var(--font-size-body5)', 
        color: 'var(--Text-Tertiary)', 
        marginTop: 'var(--spacing-xs)' 
      }}>
        Notes are saved automatically
      </div>
    </div>
  );
};

export default ProjectNotes;